import get from 'lodash/get';
import some from 'lodash/some';
import { INTERNAL_ACTION_TYPE } from 'src/presentation/components/pages/chat/chatConstants';
import { ValidationArguments, registerDecorator, ValidationOptions } from 'class-validator';
import validator from 'validator';

export function QuickActionsAreValid(validationOptions?: ValidationOptions) {
  return function (object: Object, propertyName: string) {
    registerDecorator({
      name: 'QuickActionsAreValid',
      target: object.constructor,
      propertyName: propertyName,
      options: validationOptions,
      validator: {
        validate(currentValue: string) {
          if (currentValue === undefined) {
            return true;
          }
          const hasActionsWithEmptyValues = some(
            currentValue,
            action => !get(action, 'name') && !get(action, 'content.value')
          );

          if (currentValue.length !== 4 || hasActionsWithEmptyValues) {
            return false;
          }

          return true;
        },

        defaultMessage() {
          return 'You must have all 4 actions';
        },
      },
    });
  };
}

export function ActionValueIsValid(validationOptions?: ValidationOptions) {
  return function (object: Object, propertyName: string) {
    registerDecorator({
      name: 'ActionValueIsValid',
      target: object.constructor,
      propertyName: propertyName,
      options: validationOptions,
      validator: {
        validate(currentValue: string, args: ValidationArguments) {
          return !validateAction(args);
        },

        defaultMessage(args: ValidationArguments) {
          return validateAction(args);
        },
      },
    });
  };
}

const validateAction = args => {
  const type = get(args, 'object.type');

  if (type === INTERNAL_ACTION_TYPE) {
    return '';
  }

  const value = get(args, 'object.value');

  if (!value) {
    return 'This field cannot be blank';
  }

  if (!validator.isURL(value)) {
    return 'You need to enter a valid URL';
  }

  return '';
};
